export const ANIMATIONS = {
  animationTime:                        300,
};



export const CREATION_LOCK = {
  normalLock:                           10,
  lightLock:                            20,
  mediumLock:                           30,
  superLock:                            99,
  personalityLock:                      999,
  errorLock:                            2000,
};



export const HELPCOUNT_ADDRESS = {
  latLongCount:                         20,

  zipCount:                             8,
  
  streetMinCount:                       8,
  streetMaxCount:                       256,

  numberMinCount:                       1,
  numberMaxCount:                       30,

  complementMinCount:                   8,
  complementMaxCount:                   256,

  districtMinCount:                     3,
  districtMaxCount:                     256,

  cityMinCount:                         3,
  cityMaxCount:                         256,

  stateMinCount:                        3,
  stateMaxCount:                        100,

  countryMinCount:                      3,
  countryMaxCount:                      100,
};



export const HELPCOUNT_COMMON = {
  shortIdCount:                         5,
  tableCount:                           5,
  dayMouthCount:                        4,
  dateCount:                            8,
  hourCount:                            4,
  codeCount:                            6,
};



export const HELPCOUNT_FINCANCIAL = {
  priceCount:                           6,

  agencyCount:                          8,
  accountCount:                         8,
  dvCount:                              1,
};



export const HELPCOUNT_ORDER = {
  nameItem:                             100,
  aboutText:                            250,
  percentValue:                         3,

  numberGerenic:                        7,
};



export const HELPCOUNT_PAYMENTS = {
  creditCardMinCount:                   14,
  creditCardMaxCount:                   16,
};



export const HELPCOUNT_PROFILE = {
  nameMinCount:                         2,
  nameMaxCount:                         200,

  clientIdCount:                        10,

  publicIdCount:                        5,
  userIdPublicCount:                    10,

  cpfCount:                             11,

  cnpjCount:                            14,

  usernameMinCount:                     5,
  usernameMaxCount:                     50,

  emailMinCount:                        9,
  emailMaxCount:                        200,

  passwordMinCount:                     8,
  passwordMaxCount:                     20,

  ddiMinCount:                          1,
  ddiMaxCount:                          4,

  phoneMinCount:                        5,
  phoneMaxCount:                        25,
  
  filterCount:                          25,

  linkCount:                            255,

  notationCount:                        50,
  aboutMeCount:                         255,
  textCount:                            3000,

  ageCount:                             2,

  hourMinCount:                         1,
  hourMaxCount:                         2,
};



export const HELPCOUNT_RESERVE = {
  tableReserveCount:                    2,
  hourReserveCount:                     2,
};



export const TABLES = {
  firstPage:                            1,
  itemsPerPage:                         10,
  pagesPagination:                      5,
  optionsPerPageArray:                  [10, 20, 30],
};



export const TIMES = {
  reRenderTime:                         50,
  mountTime:                            200,
  snackBarTime:                         1800,
  internetCheck:                        1000,
};



const Values = {
  ...ANIMATIONS,
  ...CREATION_LOCK,
  ...HELPCOUNT_ADDRESS,
  ...HELPCOUNT_COMMON,
  ...HELPCOUNT_FINCANCIAL,
  ...HELPCOUNT_ORDER,
  ...HELPCOUNT_PAYMENTS,
  ...HELPCOUNT_PROFILE,
  ...HELPCOUNT_RESERVE,
  ...TABLES,
  ...TIMES,
};



export default Values;
